import * as React from "react"
import { cn } from "@/lib/utils"

interface IconButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function IconButtonGroup({ children, className, ...props }: IconButtonGroupProps) {
  return (
    <div
      className={cn("flex items-center", className)}
      style={{
        background: "var(--lyt-bg-surface)",
        border: "1px solid var(--lyt-border-subtle)",
        borderRadius: "var(--radius-md)",
        padding: "0 4px",
        gap: 2,
      }}
      {...props}
    >
      {children}
    </div>
  )
}
